import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Shell from "./components/layout/Shell";
import TodaysSignals from "./pages/TodaysSignals";
import BillExplorer from "./pages/BillExplorer";
import BillDetail from "./pages/BillDetail";
import About from "./pages/About";
import KnowledgeBase from "./pages/KnowledgeBase";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Shell />,
    children: [
      { index: true,       element: <TodaysSignals /> },
      { path: "bills",     element: <BillExplorer /> },
      { path: "bills/:id", element: <BillDetail /> },
      { path: "knowledge", element: <KnowledgeBase /> },
      { path: "about",     element: <About /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
